import axios from 'axios';
import Vue from "vue";
import Auth from '../packages/auth/Auth';
Vue.use(Auth);
var http = axios.create({
    baseURL: "https://api." + window.location.hostname + "/api",
});
http.defaults.headers.common = {
    'Authorization': 'Bearer ' + Vue.auth.getToken(),
};
export default http;



//////////////////
// WEBPACK FOOTER
// ./src/http/index.ts
// module id = 3
// module chunks = 0